import { FC } from "react";
import Switch from "@common/components/Switch";
import { ScenarioID } from "@modules/mgp-sso/types";
import useStore from "@modules/financialplan/state";
import { Typography } from "@earned/core";

const PlanScenarioToggleSwitch: FC = () => {
  const { selectedScenario, setSelectedScenario } = useStore();
  const onClickToggleScenario = () => {
    // toggle as placeholder until i refactor popover menu
    if (selectedScenario === ScenarioID.Recommended) {
      setSelectedScenario(ScenarioID.Current);
    } else {
      setSelectedScenario(ScenarioID.Recommended);
    }
  };

  return (
    <label className="mb-3.5 flex cursor-pointer flex-row items-center gap-2">
      <Typography color="primary" variant="body-sm" weight="medium">
        {selectedScenario === ScenarioID.Recommended
          ? "With Earned Plan"
          : "Without Earned Plan"}
      </Typography>
      <Switch
        checked={selectedScenario === ScenarioID.Recommended}
        onChange={onClickToggleScenario}
      />
    </label>
  );
};

export default PlanScenarioToggleSwitch;
